import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Icons
import Rocket from "assets/images/banger/rocket.svg?react";
import RocketGlory from "assets/images/glory/rocket-glory.svg?react";

// Components
import Button from "components/atoms/Button";

// Hooks
import useTranslate from "hooks/useTranslate";

// Url
import url from "url/index";
import RocketCircle from "./rocket-elipse.webp";

import "./styles.sass";

const GameHistoryEmpty = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  return (
    <div className="GameHistoryEmpty">
      <div className="GameHistoryEmpty__block">
        <div className="GameHistoryEmpty__image">
          {VITE_APP_PROJECT_NAME === "banger" ? (
            <Rocket />
          ) : (
            <div className="GameHistoryEmpty__image-wrapper">
              <RocketGlory className="GameHistoryEmpty__image-icon" />
              <div className="GameHistoryEmpty__image-circle">
                <img src={RocketCircle} alt="rocketCircle" />
              </div>
            </div>
          )}
        </div>
        <div className="GameHistoryEmpty__title">{t("profile.game.title")}</div>
        <div className="GameHistoryEmpty__text">
          {t("profile.game.description")}
        </div>
        <div className="GameHistoryEmpty__btn">
          <Button
            variation="primary"
            label="profile.game.button"
            onClick={() => navigate(makeLangUrl(url.routes.casino.index()))}
          />
        </div>
      </div>
    </div>
  );
};

export default GameHistoryEmpty;
